if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.content = this.querySelector('[role="document"]');
        this.nav = this.querySelector('.product-media-modal__nav');
        this.currentEl = this.querySelector('.slider-counter--current');
        this.dots = this.nav?.querySelectorAll('[data-index]');
        this.nav?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.nav?.addEventListener('click', (event) => {
          const target = event.target.closest('[data-index], [name]');
          if (!target) return;
          if (target.dataset.index != null) this.activate(this.items[+target.dataset.index]);
          else this.step(target.name === 'next' ? 1 : -1);
        });
        this.addEventListener('keyup', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.code === 'ArrowRight') this.step(1);
          if (event.code === 'ArrowLeft') this.step(-1);
        });
        let startX = 0;
        this.content.addEventListener('touchstart', (event) => {
          startX = event.changedTouches[0].screenX;
        }, { passive: true });
        this.content.addEventListener('touchend', (event) => {
          const delta = event.changedTouches[0].screenX - startX;
          if (Math.abs(delta) > 50) this.step(delta < 0 ? 1 : -1);
        }, { passive: true });
      }

      get items() {
        const all = [...this.content.querySelectorAll(':scope > [data-media-id]')];
        const firstVariant = all.find((el) => el.classList.contains('product__media-item--variant'));
        return all.filter((el) => !el.classList.contains('product__media-item--variant') || el === firstVariant);
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const id = this.openedBy.getAttribute('data-media-id');
        this.activate(this.content.querySelector(`[data-media-id="${id}"]`) || this.items[0]);
      }

      step(dir) {
        const items = this.items;
        if (items.length < 2) return;
        const index = items.findIndex((el) => el.classList.contains('active'));
        this.activate(items[(index + dir + items.length) % items.length]);
      }

      activate(media) {
        if (!media) return;
        window.pauseAllMedia();
        const items = this.items;
        items.forEach((el) => el.classList.remove('active'));
        media.classList.add('active');
        const index = items.indexOf(media);
        if (this.currentEl) this.currentEl.textContent = index + 1;
        this.dots?.forEach((dot, i) => {
          dot.classList.toggle('slider-counter__link--active', i === index);
          dot.setAttribute('aria-current', i === index);
        });
        const template = media.querySelector('template');
        if (media.nodeName === 'DEFERRED-MEDIA' && template?.content.querySelector('.js-youtube')) {
          media.loadContent();
        }
      }
    }
  );
}
